import { Component, HostBinding, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'a[app-instgram-logo]',
  imports: [],
  templateUrl: './instgram-logo.html',
  styleUrl: './instgram-logo.scss',
})
export class InstgramLogo {
  @Input() size: number = 40;

  @HostBinding('attr.href')
  get href(): string {
    return environment.ig;
  }

  @HostBinding('attr.target')
  get target(): string {
    return '_blank';
  }
  @HostBinding('attr.rel')
  get rel(): string {
    return 'noopener noreferrer';
  }

  get appname(): string {
    return environment.appname;
  }
}
